import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { NormalBenefit } from '../../types/benefit';
import { SubItem } from '../sub-item/SubItem';

export const NormalItem = React.forwardRef<HTMLDivElement, NormalBenefit>((props, ref) => {
  // React 18 PropsWithoutRef strips 'ref' from props; restore via type assertion
  const item = props as NormalBenefit;
  return (
    <Container key={item.title} ref={item.ref}>
      <ItemContainer>
        <Text variant='Body_13_Medium' color='textTertiary'>
          {item.title}
        </Text>
        <SubItemContainer>
          {item.items.map((subItem) => (
            <SubItem key={subItem.content} subItem={subItem} />
          ))}
        </SubItemContainer>
      </ItemContainer>
    </Container>
  );
});

const Container = styled.div`
  padding: 0 10px 10px 10px;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 4px;
  background: ${vars.color.fillDisabled};
`;

const SubItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
